module.exports = __webpack_public_path__ + "static/img/o_consultation2.a7eedc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/o_consultation2.png
// module id = 755
// module chunks = 1